import React from "react";
import { withRouter } from "react-router";
import { API } from "aws-amplify";
import { toast } from "react-toastify";
import _ from "lodash";

import ConfirmModal from "@/common/ConfirmModal";
import Modal from "@/common/Modal";

import EditTenant from "./EditTenant";
import {useDispatch} from "react-redux";
import {refreshTenantFeatures} from '@/shared/user/actions';

const HIDDEN_FEATURE_FLAGS = [
    "ACTIVITY_EMAIL_DIGEST",
    "PRINT_SURVEY_RESULTS",
    "SURVEY_OPTOUT_INSTRUCTIONS",
    "LOOKER_REPORTS",
    "IGNORE_SURVEY_ANSWER",
    "EXPANDED_SENTIMENT_TYPES",
    "AI_SENTIMENT_ANALYSIS",
    "AI_DISCLOSURE",
    "AI_INLINE_SUMMARIZATION"
];

function SupportSingleTenant(props) {
    const [tenantId] = React.useState(props.match.params.tenantId);
    const [tenant, setTenant] = React.useState(null);
    const [featureFlags, setFeatureFlags] = React.useState([]);
    const [tenantDashboards, setTenantDashboards] = React.useState([]);
    const [tenantRoles, setTenantRoles] = React.useState([]);
    const [editOpen, setEditOpen] = React.useState(false);
    const dispatch = useDispatch();

    const loadTenant = (tenantId) => {
        API.get('Core', '/api/v1/support-tools/tenants/' + tenantId)
            .then(response => {
                setTenant(Object.assign({}, response));
            },
                error => {
                    toast("Could not load tenants: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const loadTenantRoles = (tenantId) => {
        API.get('Core', '/api/v1/support-tools/tenants/' + tenantId + '/roles')
            .then(response => {
                setTenantRoles(Object.assign([], response));
            },
                error => {
                    toast("Could not load tenants: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const loadFeatureFlags = (tenantId) => {
        API.get('Core', '/api/v1/support-tools/feature-flags')
            .then(response => {
                setFeatureFlags(Object.assign([], response));
            },
                error => {
                    toast("Could not load tenants: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const assumeRole = (roleId) => {
        API.post('Core', '/api/v1/support-tools/tenants/' + tenantId + '/roles/' + roleId + '/assume')
            .then(response => {
                window.location = "/";
            },
                error => {
                    toast("Could not switch into role: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const loadTenantDashboards = (tenantId) => {
        API.get('Core', '/api/v1/analytics/dashboard/tenant/' + tenantId)
            .then(response => {
                setTenantDashboards(response);
            },
                error => {
                    toast("Could not load this tenants dashboards: " + error.response.data.message, { position: "top-center", type: "error" });
                })
    }

    const onEditSuccess = () => {
        setEditOpen(false);
        loadTenant(tenantId);
    }

    const onFeatureToggle = (feature) => {
        API.put('Core', '/api/v1/support-tools/tenants/' + tenant.id + '/toggle-feature/' + feature.name)
            .then(response => {
                let message = "Successfully toggled feature: " + feature.name + "!";
                if (response && response.autoDisabledFeature) {
                    message += " " + response.autoDisabledFeature + " has been automatically disabled.";
                }
                toast(message, { position: "top-center", type: "success" });
                loadTenant(tenantId);
                dispatch(refreshTenantFeatures())
            },
                error => {
                    toast("Could not toggle feature: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    const onSysDashboardToggle = (dashboardId) => {
        API.put('Core', '/api/v1/analytics/dashboard/tenant/' + tenant.id + '/system-dashboard/' + dashboardId)
            .then(response => {
                toast("Successfully toggled dashboard!", { position: "top-center", type: "success" });
                loadTenantDashboards(tenantId);
            },
                error => {
                    toast("Could not toggle dashboard: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    React.useEffect(() => {
        loadTenant(tenantId);
        loadTenantRoles(tenantId);
        loadTenantDashboards(tenantId);
        loadFeatureFlags();
    }, [tenantId]);

    if (!tenant || !tenantRoles) {
        return (<span>Loading...</span>);
    }

    return (
        <div className="rootView surveysView">
            <div className="navBar">
                <div className="navTitle">
                    <div className="title">TENANT: {tenant.name}</div>
                </div>
                <div className="actions">
                    <div className="">
                        <Modal
                            button={(<div className="button medium action">
                                <div className="buttonTitle">Edit Tenant</div>
                            </div>)}
                            content={(<EditTenant tenant={tenant} onSuccess={onEditSuccess} onCancel={() => setEditOpen(false)} />)}
                            title="Edit Tenant"
                            size="large"
                            handleClose={() => setEditOpen(false)}
                            handleOpen={() => setEditOpen(true)}
                            open={editOpen}
                        />
                    </div>
                </div>
                <div className="separator"></div>
            </div>
            <div className="scrollView">
                <div className="tableView">
                    <div className="tableSection">
                        <div className="sectionTitle">Tenant Roles</div>
                        {
                            _.map(_.sortBy(tenantRoles, function (r) {
                                return r.name;
                            }), function (role, k) {
                                return (
                                    <div key={role.id} className="tableCell">
                                        <div className="cellBody">
                                            <div className="title groupName">{role.name}</div>
                                            <div className={"detail"} style={{ textAlign: 'left' }}>
                                                <span>{role.privileges.length} permissions</span>
                                            </div>
                                        </div>
                                        <div className={"cellActions"}>
                                            <ConfirmModal
                                                title={"Assume Role"}
                                                text={(<span>Are you sure you want to assume <b>{role.name}</b> in <b>{tenant.name}</b>?</span>)}
                                                onConfirm={assumeRole.bind(this, role.id)}
                                                confirmTitle={"Assume Role"}
                                            >
                                                <div className="cellAction button small destructiveProminent">
                                                    <div className="title">Assume Role</div>
                                                </div>
                                            </ConfirmModal>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="tableSection">
                        <div className="sectionTitle">Feature Flags</div>
                        {
                            _.map(_.sortBy(_.filter(featureFlags, function (f) {
                                if (HIDDEN_FEATURE_FLAGS.includes(f.name)) return false;
                                return true;
                            }), function (f) {
                                return f.name;
                            }), function (feature, j) {
                                let active = _.findIndex(tenant.features, function (ft) { return ft.feature === feature.name; }) !== -1;
                                return (
                                    <div key={feature.name} className="tableCell">
                                        <div className="cellBody">
                                            <div className="title groupName">{feature.name}</div>
                                            <div className={"detail"} style={{ textAlign: 'left' }}>
                                                {feature.description}
                                            </div>
                                            <div style={{ cursor: 'pointer', display: 'block', position: 'absolute', top: '20px', right: '15px' }} onClick={onFeatureToggle.bind(this, feature)} className={`accessory accessorySwitch ${active ? 'on' : 'off'}`}>
                                                <div className="switchThumb" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className="tableSection">
                        <div className="sectionTitle">Measure Dashboards</div>
                        {
                            _.map(_.sortBy(tenantDashboards, td => td.weight), function (dash) {
                                return (
                                    <div key={dash.dashboardId} className="tableCell">
                                        <div className="cellBody">
                                            <div className="title groupName">{dash.name} ({dash.quicksightId || dash.dashboardId})</div>
                                            <div className={"detail"} style={{ textAlign: 'left' }}>
                                                <span>SYSTEM DASHBOARD</span>
                                            </div>
                                            <div style={{ cursor: 'pointer', display: 'block', position: 'absolute', top: '20px', right: '15px' }} onClick={onSysDashboardToggle.bind(this, dash.dashboardId)} className={`accessory accessorySwitch ${dash.enabled ? 'on' : 'off'}`}>
                                                <div className="switchThumb" />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(SupportSingleTenant);